import React, { useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Carousel, Card } from 'react-bootstrap';

import { Link } from 'react-router-dom';
import angolo from '../img/Progetti/angolo2.jpg'; // Imposta il percorso corretto per l'immagine originale
import angoloGrigio from '../img/Progetti/angoloGrigio.png';

import vlecvihurst from '../img/Progetti/vlecvi/sfondoVlecvi.jpg';




const Progetti = () => {
  useEffect(() => {
    function updateImageBasedOnWidth() {
        const cardImage = document.querySelector('.imgBordi1');
        if (!cardImage) return;
        const windowWidth = window.innerWidth;

        if (windowWidth <= 525) {
          cardImage.src = angoloGrigio; // Cambia l'immagine quando la larghezza è inferiore o uguale a 600px

        } else {
          cardImage.src = angolo; // Ripristina l'immagine originale quando la larghezza è superiore a 600px

        }
      }

    window.addEventListener('resize', updateImageBasedOnWidth);

    // Chiama la funzione all'inizio per impostare l'immagine iniziale in base alla larghezza corrente
    updateImageBasedOnWidth();

    // Rimuovi il listener quando il componente si smonta per evitare memory leak
    return () => {
      window.removeEventListener('resize', updateImageBasedOnWidth);
    };
  }, []); // Assicura che useEffect venga eseguito solo una volta durante il montaggio del componente

  return (
    <div>
      <Container fluid>
        <Row>

          <Col className=" ProgettiColonna">
          <div data-aos="fade-right">

          <Carousel className="hideCarouselControls" interval={4000} pause={false} >
      
        <Carousel.Item>
                 <Card className='marginiCard' style={{ textAlign: "center" }}>
                   <Card.Img variant="top" src={vlecvihurst} className='imgBordi2' />
                   <span className="badge bg-light text-dark ms-auto"> Progetto</span>
                   <Card.Body className='posizioneTesto'>
                     <Card.Title>VlecviBot - Dolcevita</Card.Title>
                     <Card.Text>
                    Progetto inerente la costruzione di un software algoritmico per operare sui mercati finanziari in particolare sul mercato dell'oro.
                    </Card.Text>
                    <Link to="/vlecvibot" className='buttonRadius btn btn-dark buttonSpacing'>Apri il Progetto</Link>
                   </Card.Body>
                 </Card>
               </Carousel.Item>
               
      <Carousel.Item>
            <Card className='marginiCard' style={{ textAlign: "center" }}>
              <Card.Img variant="top" src={angolo} className='imgBordi1' />
              <span className="badge bg-light text-dark ms-auto"> Progetto</span>
              <Card.Body className='posizioneTesto'>
                <Card.Title>Sito Web - "Da Giannino L'Angolo D'Abruzzo"</Card.Title>
                <Card.Text>
                  Ideazione e creazione del Sito Web del ristorante Da Giannino l'Angolo d'Abruzzo.
                </Card.Text>
                <a className='buttonRadius btn btn-dark' href='http://www.da-giannino-langolo-dabruzzo.it' target="_blank" rel="noreferrer">Apri il Progetto</a>
              </Card.Body>
            </Card>
            </Carousel.Item>

            


            </Carousel>
            </div>
            


          </Col>
         
          <Col id="ColHover" className=' thumb1 colRight ' md={2}>
            <div data-aos="fade-left">
            <Link to="progetti">
              <h1 className='vertical-rl1'><small className='more'>More to</small> Progetti</h1>
            </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Progetti;
